import { Action, RecommendedAction } from "actions/types/Action";

const STORAGE_KEY = 'recommendedActions';

export const RecommendedActionsCache = {
  add: (action: RecommendedAction) => {
    const current = RecommendedActionsCache.getAll();
    current.push(action);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
  },

  getAll: (): RecommendedAction[] => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      console.warn('Failed to parse recommended actions from cache:', e);
      return [];
    }
  },

  getAllActions: (eventId: string | null): Action[] => {
    try {
      const stored = RecommendedActionsCache.getAll();
      const filtered = (eventId !== null)? stored.filter(sa => sa.eventId === eventId) : stored;
      console.log(`Filtered actions amount for event ${eventId} = ${filtered.length}`);
      return filtered.map((ra) => ({
        id: ra.id,
        title: ra.title,
        description: ra.description,
        requirement: null,
        frequency: null,
        piResource: null,
        resourceUrl: null,
        source: ra.source,
        sdg: ra.sdg ?? null,
      }));
    } catch (e) {
      console.warn("Failed to parse recommended actions from cache:", e);
      return [];
    }
  },

  clear: () => {
    localStorage.removeItem(STORAGE_KEY);
  },
};
